import styled from 'styled-components';
import { alpha } from 'utils/ui';
import { fillParent } from 'styles/mixins';
import Box from 'components/Box';
var SelectionIndicator = styled(Box).withConfig({
  displayName: "SelectionIndicator",
  componentId: "sc-s2ltkr-0"
})(["", " z-index:", ";background-color:", ";border-left:5px solid ", ";"], fillParent, function (p) {
  return p.theme.globals.z.below;
}, function (p) {
  return alpha(p.theme.links, p.theme.shadeStrength);
}, function (p) {
  return p.theme.links;
});
export default SelectionIndicator;